import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloDataSource, cleanAloDataSource } from '@/models/alo/AloDataSource'
import { ApiResultCode } from '@/enum/ApiResultCode'

export default {
  getAllDataSource(): AxiosPromise<AlrContainer<Array<AloDataSource>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/DataSource`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloDataSource>>
      }]
    })
  },
  getDataSource(id:number):AxiosPromise<AlrContainer<AloDataSource>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/DataSource/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloDataSource>
      }]
    })
  },
  saveDataSource(dataSource:AloDataSource):AxiosPromise<AlrContainer<AloDataSource>> {
    cleanAloDataSource(dataSource)
    if(dataSource.id) {
      const oldId = dataSource.id
      dataSource.id = dataSource.newId
      delete dataSource.newId
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/DataSource/${oldId}`, 
        method: 'PUT',
        data: dataSource,
        transformResponse: [function (data:string) {    
          const  resp = JSON.parse(data) as AlrContainer<AloDataSource>
          if(resp.resultCode == ApiResultCode.Ok){
            //@ts-ignore
            resp.data.newId = oldId
          }
          return resp
        }]
      })    
    }
    else{
      dataSource.id = dataSource.newId
      delete dataSource.newId
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/DataSource`, 
        method: 'POST',
        data: dataSource,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloDataSource>
        }]
      })    
    }
  },
  deleteDataSource(id:number){
    return  apiHelpers.apiCall({ 
      url: `/webapi/api/admin/DataSource/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<number>
      }]
    })
  }
}